import { Container, ContainerProps } from '~/components/layout';
import { Text } from '~/components/typography';
import { CalloutContainer, BackgroundOption } from './text-callout.style';

export interface TextCalloutProps extends ContainerProps {
  background?: BackgroundOption;
  body: string;
  header: string;
  icon?: keyof typeof ICONS;
}

export const TextCallout = ({
  background = 'success',
  body,
  header,
  icon,
  ...containerProps
}: TextCalloutProps) => {
  const Icon = icon && ICONS[icon];
  return (
    <CalloutContainer background={background} {...containerProps}>
      {Icon && (
        <Container mr={3}>
          <Icon />
        </Container>
      )}
      <Container width="90%">
        <Text color="primary" mb={1} textStyle="paragraph500">
          {header}
        </Text>
        <Text color="secondary" textStyle="paragraph400">
          {body}
        </Text>
      </Container>
    </CalloutContainer>
  );
};

const LightningDollarIcon = () => (
  <svg width="41" height="43" viewBox="0 0 41 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5481 42.92C27.0995 42.92 34.8423 35.1771 34.8423 25.6258C34.8423 16.0744 27.0995 8.33154 17.5481 8.33154C7.99679 8.33154 0.253906 16.0744 0.253906 25.6258C0.253906 35.1771 7.99679 42.92 17.5481 42.92Z"
      fill="#0B1F1C"
    />
    <path
      d="M18.5121 13.6602L10.375 26.7249L16.9513 26.7076L14.8471 37.6L24.4931 21.9124L17.7979 21.9694L18.5121 13.6602Z"
      fill="#0EFF85"
    />
    <path
      d="M31.3333 18.3599C36.26 18.3599 40.2539 14.366 40.2539 9.43921C40.2539 4.51247 36.26 0.518555 31.3333 0.518555C26.4065 0.518555 22.4126 4.51247 22.4126 9.43921C22.4126 14.366 26.4065 18.3599 31.3333 18.3599Z"
      fill="#B7EDED"
    />
    <path
      d="M30.9252 14.868V13.9161C30.1173 13.8246 29.4704 13.5399 28.9844 13.0621C28.4983 12.5843 28.2508 11.958 28.2417 11.1831H29.6268C29.6287 11.5517 29.7504 11.9096 29.9733 12.2031C30.211 12.5053 30.5484 12.7132 30.9252 12.7898V9.81044C30.8596 9.79435 30.7915 9.77331 30.721 9.74855L30.5056 9.678C29.8372 9.4552 29.3363 9.16639 29.0029 8.81156C28.6696 8.45673 28.5045 7.99091 28.5078 7.41411C28.4928 7.10706 28.5435 6.80034 28.6567 6.5145C28.7698 6.22866 28.9427 5.97029 29.1638 5.75672C29.6078 5.32845 30.197 5.07718 30.9314 5.00292V4.0127H31.7731V5.01158C32.4893 5.0941 33.067 5.35403 33.506 5.79138C33.721 6.00722 33.8905 6.26403 34.0045 6.5466C34.1185 6.82917 34.1745 7.13174 34.1694 7.43639H32.7806C32.7703 7.15789 32.6777 6.88871 32.5145 6.66278C32.3337 6.41469 32.0704 6.23915 31.7718 6.16766V8.81156C31.8374 8.83631 31.903 8.85859 31.9686 8.87963C32.0342 8.90068 32.1011 8.92172 32.1667 8.94647C32.5669 9.07436 32.9524 9.24448 33.3166 9.45396C33.6461 9.64374 33.9244 9.91097 34.1273 10.2325C34.3421 10.6037 34.4472 11.0282 34.4306 11.4567C34.4328 11.8616 34.3305 12.2602 34.1335 12.614C33.9214 12.9862 33.6143 13.2955 33.2436 13.5102C32.7931 13.7648 32.2888 13.909 31.7718 13.931V14.8705L30.9252 14.868ZM29.8619 7.30023C29.853 7.43983 29.8738 7.57974 29.9229 7.71073C29.9719 7.84173 30.0482 7.96084 30.1466 8.06023C30.3757 8.26116 30.6395 8.41847 30.9252 8.52439V6.12558C30.6352 6.17098 30.367 6.30703 30.159 6.51424C30.0593 6.61866 29.9817 6.74204 29.9307 6.87707C29.8796 7.01209 29.8563 7.156 29.8619 7.30023ZM33.0406 11.5409C33.0406 11.1373 32.9209 10.8304 32.6816 10.6199C32.4107 10.3914 32.1009 10.2136 31.7669 10.0951V12.8182C32.119 12.7927 32.4513 12.6452 32.7064 12.4011C32.8169 12.2875 32.9035 12.1527 32.9609 12.0049C33.0183 11.8572 33.0454 11.6993 33.0406 11.5409Z"
      fill="#0B1F1C"
    />
  </svg>
);

export const ICONS = { LightningDollarIcon };
